<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar dark color="info">
          <v-toolbar-title>{{ $t('OfficeId-List') }}</v-toolbar-title>
          <v-spacer></v-spacer>

          <v-text-field
            flat
            solo-inverted
            hide-details
            v-model="search"
            :label="$t('Search')"
            append-icon="search"
            class="mr-3"
            style="max-width: 250px"
          ></v-text-field>

          <v-btn color="white" flat @click="yeniKayitAc">
            <v-icon left>add</v-icon>
            {{ $t('Add-OfficeId') }}
          </v-btn>
        </v-toolbar>
      </v-flex>

      <v-flex xs12>
        <v-card flat>
          <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            :loading="loading"
            :rows-per-page-items="[10, 25, 50, 100]"
            class="elevation-1"
          >
            <template slot="items" slot-scope="props">
              <tr>
                <td class="text-xs-left">{{ props.item.Gds }}</td>
                <td class="text-xs-left">{{ props.item.OfficeId }}</td>
                <td class="text-xs-left">{{ props.item.CariKod }}</td>
                <td class="text-xs-left">{{ props.item.MasrafMerkeziKodu }}</td>
                
                <td class="text-xs-left">
                  <v-btn small icon color="warning" @click="duzenleAc(props.item)">
                    <v-icon>edit</v-icon>
                  </v-btn>

                  <v-btn small icon color="error" @click="sil(props.item)">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>

            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
            >
              {{ $t('No-records-searched-for', { value: search }) }}
            </v-alert>

            <template slot="no-data">
              <v-alert :value="true" color="info" icon="info">
                {{ $t('No-Data-Found') }}
              </v-alert>
            </template>

            <v-progress-linear
              slot="progress"
              indeterminate
              color="info"
            ></v-progress-linear>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title class="headline grey lighten-3">
          {{ formTitle }}
        </v-card-title>

        <v-card-text>
          <v-container fluid>
            <v-layout row wrap>
              <v-flex xs12 sm12 md6>
                <v-select
                  :items="gdsItems"
                  v-model="form.Gds"
                  label="Gds"
                  item-text="text"
                  item-value="value"
                ></v-select>
              </v-flex>

              <v-flex xs12 sm12 md6>
                <v-text-field
                  v-model="form.OfficeId"
                  label="OfficeId"
                  maxlength="50"
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <cariaracomp
                  v-model="form.CariKod"
                  :etiket="$t('Currentcode_label')"
                ></cariaracomp>
              </v-flex>

              <v-flex xs12>
  <v-text-field
    v-model="form.MasrafMerkeziKodu"
    label="Masraf Merkezi Kodu"
    maxlength="50"
  ></v-text-field>
</v-flex>

             
            </v-layout>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="dialogKapat">{{$t('Cancel')}}</v-btn>
          <v-btn color="info" :loading="saveLoading" @click="kaydet">
            {{$t('save_button')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-card>
        <v-card-title class="headline">{{$t('Delete')}}</v-card-title>
        <v-card-text>
          {{$t('Do-you-want-to-delete-this-record?')}}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="deleteDialog = false">{{$t('Cancel')}}</v-btn>
          <v-btn color="error" :loading="deleteLoading" @click="silOnay">
            {{$t('Delete')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      :timeout="timeout"
      :top="y === 'top'"
      :bottom="y === 'bottom'"
      :right="x === 'right'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :vertical="mode === 'vertical'"
      v-model="snackbar"
    >
      {{ text1 }}
      <v-btn flat color="pink" @click.native="snackbar = false">
        {{ $t('Close') }}
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import auth from "../../../api/auth";
import cariaracomp from '@/components/app/customcomp/cariaracomp'

export default {
  data() {
    return {
      loading: false,
      saveLoading: false,
      deleteLoading: false,
      dialog: false,
      deleteDialog: false,
      search: "",
      items: [],
      selectedItem: null,

      headers: [
        { text: "Gds", value: "Gds" },
        { text: "OfficeId", value: "OfficeId" },
        { text: "Cari Kod", value: "CariKod" },
        { text: "Masraf Merkezi", value: "MasrafMerkeziKodu" },
        { text: "İşlem", value: "islem", sortable: false }
      ],

      gdsItems: [
        { text: "AMADEUS", value: "AMADEUS" },
        { text: "SABRE", value: "SABRE" },
        { text: "GALILEO", value: "GALILEO" }
      ],

      formMode: "insert",
      form: {
        Id: 0,
        Gds: null,
        OfficeId: "",
        CariKod: "",
        CariUnvan: "",
        MasrafMerkeziKodu: ""
      },

      snackbar: false,
      text1: "",
      y: "top",
      x: "right",
      mode: "",
      timeout: 6000
    };
  },

  computed: {
    formTitle() {
      return this.formMode === "update"
        ? "OfficeId Tanım Güncelle"
        : "Yeni OfficeId Tanımı";
    }
  },
  components:{
    cariaracomp
  },

  mounted() {
    this.listele();
  },

  methods: {
    varsayilanForm() {
      return {
        Id: 0,
        Gds: null,
        OfficeId: "",
        CariKod: "",
        CariUnvan: "",
        MasrafMerkeziKodu: ""
      };
    },

    listele() {
      this.loading = true;

      var credentials = JSON.parse(window.localStorage.getItem("credentials"));
      var params = {
        SirketKodu: credentials.SirketKodu
      };

      this.$http.post(auth.API_URL + "api/Ticket/GdsOfficeCariMapList", params, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader()
        }
      }).then((response) => {
        this.items = response.body || [];
        this.loading = false;
      }, (response) => {
        this.loading = false;
        this.text1 = "Service Unavailable";
        this.snackbar = true;
      });
    },

    yeniKayitAc() {
      this.formMode = "insert";
      this.form = this.varsayilanForm();
      this.dialog = true;
    },

    duzenleAc(item) {
      this.formMode = "update";
      this.form = {
        Id: item.Id || 0,
        Gds: item.Gds || null,
        OfficeId: item.OfficeId || "",
        CariKod: item.CariKod || "",
        CariUnvan: item.CariUnvan || "",
        MasrafMerkeziKodu: item.MasrafMerkeziKodu || ""
      };
      this.dialog = true;
    },

    dialogKapat() {
      this.dialog = false;
      this.form = this.varsayilanForm();
    },

    kaydet() {
  if (!this.form.Gds || !this.form.OfficeId || !this.form.CariKod) {
    this.text1 = "Gds, OfficeId ve Cari Kod zorunludur.";
    this.snackbar = true;
    return;
  }

  this.saveLoading = true;

  var credentials = JSON.parse(window.localStorage.getItem("credentials"));
  var params = {
    Id: this.form.Id,
    SirketKodu: credentials.SirketKodu,
    Gds: this.form.Gds,
    OfficeId: this.form.OfficeId,
    CariKod: this.form.CariKod,
    CariUnvan: this.form.CariUnvan,
    MasrafMerkeziKodu: this.form.MasrafMerkeziKodu
  };

  this.$http.post(auth.API_URL + "api/Ticket/GdsOfficeCariMapSave", params, {
    headers: {
      Authorization: "Bearer " + auth.getAuthHeader()
    }
  }).then((response) => {
    this.saveLoading = false;
    this.text1 = response.body && response.body.ResponseMessage
      ? response.body.ResponseMessage
      : "Kayıt başarıyla kaydedildi.";
    this.snackbar = true;
    this.dialogKapat();
    this.listele();
  }, (response) => {
    this.saveLoading = false;
    this.text1 = "Service Unavailable";
    this.snackbar = true;
  });
},

    sil(item) {
  this.selectedItem = {
    SirketKodu: item.SirketKodu || 0,
    Gds: item.Gds || "",
    OfficeId: item.OfficeId || "",
    CariKod: item.CariKod || ""
  };
  this.deleteDialog = true;
},

    silOnay() {
  if (!this.selectedItem) {
    return;
  }

  this.deleteLoading = true;

  var credentials = JSON.parse(window.localStorage.getItem("credentials"));
  var params = {
    SirketKodu: credentials.SirketKodu,
    Gds: this.selectedItem.Gds,
    OfficeId: this.selectedItem.OfficeId,
    CariKod: this.selectedItem.CariKod
  };

  this.$http.post(auth.API_URL + "api/Ticket/GdsOfficeCariMapDelete", params, {
    headers: {
      Authorization: "Bearer " + auth.getAuthHeader()
    }
  }).then((response) => {
    this.deleteLoading = false;
    this.deleteDialog = false;
    this.text1 = response.body && response.body.ResponseMessage
      ? response.body.ResponseMessage
      : "Kayıt silindi.";
    this.snackbar = true;
    this.selectedItem = null;
    this.listele();
  }, (response) => {
    this.deleteLoading = false;
    this.deleteDialog = false;
    this.text1 = response.body && response.body.ResponseMessage
      ? response.body.ResponseMessage
      : "Service Unavailable";
    this.snackbar = true;
  });
},
  }
};
</script>

<style>
</style>